import gql from 'graphql-tag';

export const GetAllTestsBabyQuery = gql`
query GetAllTestsBaby($id: uuid!) {
  baby(id: $id) {
    tests {
      baby {
        tests {
          ageInMonths
          id
          createdAt
          diversity(path: "genus")
          status
        }
      }
    }
  }
}`

